// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__oab-u","content":"Banner_content__hdMOP","subtitle":"Banner_subtitle__jGV4V","text":"Banner_text__-prR+","image":"Banner_image__laIQI"};